module.exports = __webpack_public_path__ + "img/icon-empty.5170d8b1.png";